import type { TFunction } from 'i18next';

/**
 * Meta per-product failure codes (integration PR #814) → copy keys under
 * `deliveries:metaFailure`. A product state carries one of these in `errorCode`
 * (or the read-back ones in `ingestReason`); Graph's numeric codes and anything
 * new fall through to the server's own message.
 */
const META_FAILURE_KEYS: Record<string, string> = {
  META_BATCH_ITEM_ERROR: 'batchItemError',
  META_BATCH_FAILED: 'batchFailed',
  META_DUPLICATE_RETAILER_ID: 'duplicateRetailerId',
  META_FEED_ITEM_ERROR: 'feedItemError',
  META_FEED_UPLOAD_REJECTED: 'feedUploadRejected',
  META_REVIEW_REJECTED: 'reviewRejected',
  META_NOT_APPLIED: 'notApplied',
  META_OUT_OF_STOCK: 'outOfStock',
};

/** Short readable label for a Meta failure code, or null when the code isn't one of ours. */
export function metaFailureLabel(
  code: string | null | undefined,
  t: TFunction<'deliveries'>,
): string | null {
  const key = code ? META_FAILURE_KEYS[code] : undefined;
  return key ? t(`metaFailure.${key}`) : null;
}

/** The first Meta failure label among a row's `errorCode` / `ingestReason`, else null. */
export function metaFailureLabelForRow(
  row: { errorCode?: string | null; ingestReason?: string | null },
  t: TFunction<'deliveries'>,
): string | null {
  return metaFailureLabel(row.errorCode, t) ?? metaFailureLabel(row.ingestReason, t);
}
